import React, {useState} from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import FormControl from 'react-bootstrap/es/FormControl'
import FormGroup from 'react-bootstrap/es/FormGroup'
import InputGroup from 'react-bootstrap/es/InputGroup'

const styles = theme => ({
	cursorDefault: {
		cursor: 'default'
	}
});

const SearchInput = ({params, setParams, classes, placeholder}) => {
	const [query, setQuery] = useState(params.query);
	return <FormGroup>
		<InputGroup>
			<InputGroup.Addon onClick={() => {
				setQuery('');
				setParams({query: null, page: null});
			}} className={classes.cursorDefault}>x</InputGroup.Addon>
			<FormControl
				onChange={(e) => setQuery(e.target.value)}
				onKeyDown={(event) => event.keyCode === 13 && setParams({query, page: null})}
				value={query} type="text" placeholder={placeholder}
			/>
			<InputGroup.Addon onClick={() => setParams({query, page: null})} className={classes.cursorDefault}>Show</InputGroup.Addon>
		</InputGroup>
	</FormGroup>;
};

SearchInput.propTypes = {
	params: PropTypes.object,
	setParams: PropTypes.func,
	placeholder: PropTypes.string,
};

SearchInput.defaultProps = {
	placeholder: 'Title'
};

export default injectSheet(styles)(SearchInput);
